import { AxiosPromise } from 'axios';
import { utils } from 'ui-common';
import baseRequest from './baseRequest';

const { featureFlags } = utils;

// TODO AO-534: deprecate this when the new config schema is used everywhere
export interface ProductOld {
  _id: string;
  referenceId: string;
  title: string;
  text: string;
  subText: string;
  accounts: {
    type: string;
    description: string;
    referenceId?: string;
  }[];
  notes?: string[];
}

export interface Product {
  title: string;
  description: string;
  accounts: {
    type: string;
    description: string;
    referenceId?: string;
  }[];
  referenceId?: string;
  detailsDisplay?: {
    body: string;
    title?: string;
    footers?: string[];
  };
}

export function getProducts(): AxiosPromise<(ProductOld | Product)[]> {
  const params = featureFlags.isEnabled('enableAccountOpeningDCSIntegration04092019')
    ? { params: { useNewProductSchema: true } }
    : undefined;
  return baseRequest.get('/api/account-opening/products', params);
}
